import { gql } from '@apollo/client';
import { PersonDetailedFragment } from 'Apollo/fragments/person/PersonDetailed';

export const GetMe = gql`
  query GetMe {
    me {
      ...PersonDetailed
    }
  }
  ${PersonDetailedFragment}
`;
